// assets içindeki custom.js dosyası bu.

/**
 * ====================================================================================================================
 * EK TEPSİ BEDELİ - Companion Line Item Sistemi
 * ====================================================================================================================
 *
 * Genel mimari:
 *
 * 1. Her ürün sayfasında render edilen <script data-tepsi-variant-data> bloğu, o ürünün hangi varyantı seçilirse hangi
 *    tepsi varyantının ek olarak ekleneceğini içerir. Bu data window.__tepsiRegistry içine toplanır.
 *
 * 2. /cart/add.js çağrıları (theme'in product form'undan FormData veya başka yerden JSON gelebilir) global fetch
 *    interceptor üzerinden yakalanır. Eğer eklenen varyantın tepsi'si varsa, istek atomik bir multi-item JSON isteğine
 *    dönüştürülür: parent ürün + tepsi ürün aynı anda eklenir.
 *
 * 3. Parent ve tepsi line item'ları "_tepsi_uid" property'si üzerinden eşleşir. UID parent variant id'sidir.
 *
 * 4. Sepet template'leri (mini-cart.liquid, main-cart.liquid) "_tepsi_fee=true" property'sine sahip line item'ları
 *    render etmeyi atlar ve parent line item'ın altında "Ek Tepsi Bedeli: ₺X" satırı gösterir.
 *
 * 5. Müşteri sepet üzerinde parent adedini değiştirince, /cart/change.js interceptor'ı tepsi adedini senkronlar.
 *
 * 6. Ürün sayfasında varyant değişince fiyat elementi güncellenir (tepsi ekli fiyat gösterilir).
 *
 * 7. Cart icon count'tan tepsi item'ları düşülür (doğru adet gösterilir).
 *
 * 8. Checkout: Tepsi gerçek bir line item olduğu için Shopify otomatik gösterir (Plus olmadan layout değiştirilemez).
 *
 * ====================================================================================================================
 */

(function () {
  'use strict';

  const TEPSI_PROP_UID = '_tepsi_uid';
  const TEPSI_PROP_FEE = '_tepsi_fee';
  const TEPSI_PROP_PARENT_VARIANT = '_tepsi_parent_variant';

  // Tüm ürün form'larından toplanan tepsi varyant haritası: parentVariantId -> { tepsi_variant_id, tepsi_price_cents, ... }
  const registry = (window.__tepsiRegistry = window.__tepsiRegistry || {});

  function collectTepsiData(scope) {
    const root = scope && scope.querySelectorAll ? scope : document;
    const dataEls = root.querySelectorAll('script[data-tepsi-variant-data]');
    dataEls.forEach(function (el) {
      let parsed = [];
      try { parsed = JSON.parse(el.textContent || '[]'); }
      catch (e) { return; }
      parsed.forEach(function (variantInfo) {
        if (!variantInfo || !variantInfo.id) return;
        if (variantInfo.tepsi_variant_id) {
          registry[variantInfo.id] = {
            tepsi_variant_id: variantInfo.tepsi_variant_id,
            tepsi_price_cents: variantInfo.tepsi_price_cents,
            tepsi_price_formatted: variantInfo.tepsi_price_formatted,
            tepsi_variant_title: variantInfo.tepsi_variant_title
          };
        }
      });
    });
  }

  function getTepsiForVariant(variantId) {
    if (!variantId) return null;
    return registry[variantId] || registry[String(variantId)] || null;
  }

  /**
   * Para miktarı biçimlendirme — Shopify moneyFormat string'ini kullanır.
   *
   * KRİTİK DÜZELTME: Bazı store'ların moneyFormat değeri HTML içerir ve aynı placeholder'ı
   * iki kez kullanır. Örn: <span data-amount='{{amount}}'>₺{{amount}}</span>
   * Regex'in global /g flag'siz kullanımı sadece ilk placeholder'ı değiştirir ve
   * ₺{{amount}} görünür metin olarak kalır. Global replace + callback ile hepsi değiştirilir.
   */
  const _tepsiMoneyFmt = (function () {
    function fmt(n, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? '.' : thousands;
      decimal = decimal == null ? ',' : decimal;
      if (isNaN(n) || n == null) return '0';
      n = (n / 100).toFixed(precision);
      const parts = n.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const centsStr = parts[1] ? decimal + parts[1] : '';
      return dollars + centsStr;
    }
    function valueForPlaceholder(cents, placeholder) {
      switch (placeholder) {
        case 'amount':                                    return fmt(cents, 2);
        case 'amount_no_decimals':                        return fmt(cents, 0);
        case 'amount_with_space_separator':               return fmt(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator':   return fmt(cents, 0, ' ', '');
        case 'amount_with_apostrophe_separator':          return fmt(cents, 2, "'", '.');
        case 'amount_no_decimals_with_comma_separator':   return fmt(cents, 0, '.', ',');
        case 'amount_with_comma_separator':               return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_apostrophe_separator': return fmt(cents, 0, "'");
        default:                                          return fmt(cents, 2);
      }
    }
    return function tepsiMoneyFmt(cents, formatOverride) {
      const format = formatOverride
        || (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat)
        || null;
      if (format && /\{\{/.test(format)) {
        return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, p) { return valueForPlaceholder(cents, p); });
      }
      return (cents / 100).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' });
    };
  }());

  /**
   * window.formatMoney monkey-patch (tema fonksiyonu).
   * Tema aynı non-global regex hatasını taşır; kargo ücretleri de ₺{{amount}} gösterir.
   * Custom.js defer ile theme.js'DEN SONRA yüklenir — fonksiyon burada güvenle değiştirilebilir.
   */
  if (typeof window.formatMoney === 'function') {
    window.formatMoney = function patchedFormatMoney(cents, format) {
      if (typeof cents === 'string') cents = parseFloat(cents.replace('.', '')) || 0;
      return _tepsiMoneyFmt(cents, format || undefined);
    };
  }

  /**
   * HTML strip yardımcısı. Shopify'ın | money filtresi bazı store konfigürasyonlarında
   * <span class='money' data-amount='...'>₺X,XX</span> gibi HTML döndürür. Bu fonksiyon
   * HTML etiketlerini soyarak yalnızca görünür metni döndürür.
   */
  function stripHtml(html) {
    if (!html) return '';
    const str = String(html);
    if (!str.includes('<')) return str;
    const tmp = document.createElement('div');
    tmp.innerHTML = str;
    return tmp.textContent || tmp.innerText || '';
  }

  // custom element'lerin de kullanabilmesi için global'e açıyoruz
  window.__tepsiStripHtml = stripHtml;

  /**
   * ----------------------------------------------------------------------------------------------------------------
   * CART COUNT DÜZELTMESİ
   * ----------------------------------------------------------------------------------------------------------------
   * CartCount custom elementi (theme.js) cart:updated ve cart:refresh event'lerinden item_count okur. Tepsi
   * item'ları da ayrı line item olduğu için count'u şişiriyor. Bunu düzeltmek için:
   *   - cart:updated event'ini intercept edip item_count'u gerçek count (tepsi'siz) ile override ediyoruz.
   *   - cart:refresh'te de aynısını yapıyoruz.
   *
   * CartCount element'ini override etmek yerine event data'yı manipüle ediyoruz — tema kodunu değiştirmeden çalışır.
   */
  function computeRealItemCount(cartItems) {
    if (!Array.isArray(cartItems)) return null;
    return cartItems.reduce(function (sum, item) {
      if (item.properties && item.properties[TEPSI_PROP_FEE] === 'true') return sum;
      return sum + (item.quantity || 0);
    }, 0);
  }

  // cart:updated ve cart:refresh event'lerini DOM'dan geçerken item_count'u düzelt.
  // capture: true ile bubbling'den önce yakalanır.
  document.documentElement.addEventListener('cart:updated', function (event) {
    if (!event.detail || !event.detail.cart) return;
    const realCount = computeRealItemCount(event.detail.cart.items);
    if (realCount !== null && realCount !== event.detail.cart.item_count) {
      try { event.detail.cart.item_count = realCount; } catch (e) { /* readonly olabilir, yoksay */ }
    }
  }, true);

  document.documentElement.addEventListener('cart:refresh', function (event) {
    if (!event.detail || !event.detail.cart) return;
    const realCount = computeRealItemCount(event.detail.cart.items);
    if (realCount !== null && event.detail.cart.item_count !== undefined) {
      try { event.detail.cart.item_count = realCount; } catch (e) { /* yoksay */ }
    }
  }, true);

  /**
   * ----------------------------------------------------------------------------------------------------------------
   * FETCH INTERCEPTOR
   * ----------------------------------------------------------------------------------------------------------------
   * - /cart/add.js çağrıları yakalanır ve ana ürüne ek olarak tepsi varyantı multi-item gövde olarak eklenir.
   * - /cart/change.js çağrıları yakalanır; tepsi sibling qty, parent qty ile atomic senkronlanır.
   *
   * Theme byfood'un ProductForm._onSubmit'i FormData kullanır; LineItemQuantity ise JSON kullanır.
   */
  const originalFetch = window.fetch;
  window.fetch = function (resource, init) {
    try {
      const url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
      if (
        init &&
        init.method &&
        String(init.method).toUpperCase() === 'POST' &&
        init.body
      ) {
        if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
          const transformed = transformAddToCartBody(init.body);
          if (transformed) {
            const newInit = Object.assign({}, init, {
              body: transformed.body,
              headers: Object.assign({}, init.headers || {}, transformed.headers)
            });
            return originalFetch.call(this, resource, newInit);
          }
        } else if (/\/cart\/change(\.js)?(\?|$)/.test(url)) {
          return interceptCartChange(resource, init);
        }
      }
    } catch (e) {
      if (window.console && console.warn) console.warn('[tepsi] fetch intercept hatası:', e);
    }
    return originalFetch.apply(this, arguments);
  };

  /**
   * /cart/change.js isteklerini ele alır:
   *   1. Orijinal isteği gönder (parent'ın quantity'sini günceller).
   *   2. Dönen cart state'ine bak; tepsi sibling'lerinin adedi parent'lardan farklıysa, /cart/update.js ile senkronla.
   *   3. Senkronlanmış response'u geri döndür (cart sayfasında reload bundan sonra olur, doğru qty ile).
   */
  async function interceptCartChange(resource, init) {
    const response = await originalFetch.call(window, resource, init);
    if (!response.ok) return response;

    let postChangeCart;
    try { postChangeCart = await response.clone().json(); }
    catch (e) { return response; }

    const updates = computeTepsiUpdates(postChangeCart);
    if (!updates) return response;

    let sections = ['mini-cart'];
    try {
      const requestBody = typeof init.body === 'string' ? JSON.parse(init.body) : null;
      if (requestBody && Array.isArray(requestBody.sections)) {
        sections = requestBody.sections;
      } else if (requestBody && typeof requestBody.sections === 'string') {
        sections = requestBody.sections.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      }
    } catch (e) { /* yoksay */ }

    try {
      const syncResponse = await originalFetch.call(window, '/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates, sections: sections })
      });
      if (syncResponse.ok) return syncResponse;
    } catch (e) {
      if (window.console && console.warn) console.warn('[tepsi] change sync hatası:', e);
    }
    return response;
  }

  function computeTepsiUpdates(cart) {
    if (!cart || !Array.isArray(cart.items)) return null;

    const groups = {};
    cart.items.forEach(function (item) {
      const uid = item.properties && item.properties[TEPSI_PROP_UID];
      if (!uid) return;
      if (!groups[uid]) groups[uid] = { parents: [], tepsis: [] };
      if (item.properties[TEPSI_PROP_FEE] === 'true') {
        groups[uid].tepsis.push(item);
      } else {
        groups[uid].parents.push(item);
      }
    });

    const updates = {};
    let needsUpdate = false;
    Object.keys(groups).forEach(function (uid) {
      const g = groups[uid];
      const totalParentQty = g.parents.reduce(function (sum, p) { return sum + (p.quantity || 0); }, 0);
      g.tepsis.forEach(function (t) {
        const target = g.parents.length === 0 ? 0 : totalParentQty;
        if ((t.quantity || 0) !== target) {
          updates[t.key] = target;
          needsUpdate = true;
        }
      });
    });

    return needsUpdate ? updates : null;
  }

  /**
   * /cart/add.js gövdesini incele; tepsi sibling'i varsa multi-item JSON'a dönüştür. Yoksa null.
   */
  function transformAddToCartBody(body) {
    let items = null;
    let sections = null;
    let sectionsUrl = null;

    if (body instanceof FormData) {
      const parsed = parseFormData(body);
      items = parsed.items;
      sections = parsed.sections;
      sectionsUrl = parsed.sectionsUrl;
    } else if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      const parsed = parseFormData(body);
      items = parsed.items;
      sections = parsed.sections;
      sectionsUrl = parsed.sectionsUrl;
    } else if (typeof body === 'string') {
      try {
        const parsed = JSON.parse(body);
        if (Array.isArray(parsed.items)) {
          items = parsed.items.map(normalizeItem);
        } else if (parsed.id) {
          items = [normalizeItem(parsed)];
        }
        if (parsed.sections) sections = parsed.sections;
        if (parsed.sections_url) sectionsUrl = parsed.sections_url;
      } catch (e) {
        return null;
      }
    } else {
      return null;
    }

    if (!items || items.length === 0) return null;

    let mutated = false;
    const expanded = [];
    items.forEach(function (item) {
      expanded.push(item);
      if (item.properties && item.properties[TEPSI_PROP_FEE] === 'true') return;
      const tepsi = getTepsiForVariant(item.id);
      if (!tepsi) return;

      const uid = String(item.id);
      item.properties = Object.assign({}, item.properties || {}, makeRecord(TEPSI_PROP_UID, uid));

      expanded.push({
        id: tepsi.tepsi_variant_id,
        quantity: item.quantity || 1,
        properties: makeRecord(TEPSI_PROP_UID, uid, TEPSI_PROP_FEE, 'true', TEPSI_PROP_PARENT_VARIANT, String(item.id))
      });
      mutated = true;
    });

    if (!mutated) return null;

    const jsonBody = { items: expanded };
    if (sections) jsonBody.sections = sections;
    if (sectionsUrl) jsonBody.sections_url = sectionsUrl;

    return {
      body: JSON.stringify(jsonBody),
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
    };
  }

  function makeRecord() {
    const out = {};
    for (let i = 0; i < arguments.length; i += 2) {
      out[arguments[i]] = arguments[i + 1];
    }
    return out;
  }

  function normalizeItem(raw) {
    return {
      id: typeof raw.id === 'string' ? parseInt(raw.id, 10) : raw.id,
      quantity: typeof raw.quantity === 'string' ? parseInt(raw.quantity, 10) : (raw.quantity || 1),
      properties: raw.properties || {},
      selling_plan: raw.selling_plan
    };
  }

  function parseFormData(formLike) {
    let id = null;
    let quantity = 1;
    let sellingPlan = null;
    const properties = {};
    const sections = [];
    let sectionsUrl = null;

    formLike.forEach(function (value, key) {
      const propMatch = key.match(/^properties\[(.+)\]$/);
      if (propMatch) {
        properties[propMatch[1]] = value;
        return;
      }
      switch (key) {
        case 'id':
          id = parseInt(value, 10) || value;
          break;
        case 'quantity':
          quantity = parseInt(value, 10) || 1;
          break;
        case 'selling_plan':
          sellingPlan = value;
          break;
        case 'sections':
          String(value).split(',').forEach(function (s) {
            const t = s.trim();
            if (t) sections.push(t);
          });
          break;
        case 'sections_url':
          sectionsUrl = value;
          break;
        default:
          break;
      }
    });

    if (!id) return { items: null };

    const item = { id: id, quantity: quantity, properties: properties };
    if (sellingPlan) item.selling_plan = sellingPlan;

    return {
      items: [item],
      sections: sections.length > 0 ? sections : null,
      sectionsUrl: sectionsUrl
    };
  }

  /**
   * ----------------------------------------------------------------------------------------------------------------
   * QUANTITY SENKRONİZASYONU (SAFETY NET)
   * ----------------------------------------------------------------------------------------------------------------
   * Üçüncü parti uygulamalar /cart/update.js ile parent qty değiştirirse safety net devreye girer.
   */
  let syncInFlight = false;

  async function syncTepsiQuantitiesFromCart(cart) {
    if (syncInFlight) return;
    const updates = computeTepsiUpdates(cart);
    if (!updates) return;
    syncInFlight = true;
    try {
      const response = await originalFetch.call(window, '/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates, sections: ['mini-cart'] })
      });
      if (response.ok) {
        const updatedCart = await response.json();
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart: updatedCart, __tepsiSync: true }
        }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { cart: updatedCart, __tepsiSync: true }
        }));
      }
    } catch (e) {
      if (window.console && console.warn) console.warn('[tepsi] safety-net sync hatası:', e);
    } finally {
      syncInFlight = false;
    }
  }

  document.documentElement.addEventListener('cart:updated', function (event) {
    if (event && event.detail && event.detail.__tepsiSync) return;
    if (event && event.detail && event.detail.cart) {
      syncTepsiQuantitiesFromCart(event.detail.cart);
    }
  });

  /**
   * ----------------------------------------------------------------------------------------------------------------
   * INIT
   * ----------------------------------------------------------------------------------------------------------------
   */
  function init(scope) {
    collectTepsiData(scope);
  }

  // Sayfa yüklenirken header'daki cart-count badge'ini de düzelt (initial Liquid render tepsi'yi sayar)
  function fixInitialCartCountBadge() {
    const badges = document.querySelectorAll('cart-count');
    if (!badges.length) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      const realCount = computeRealItemCount(cart.items);
      if (realCount === null) return;
      badges.forEach(function (el) {
        if (String(el.textContent).trim() !== String(realCount)) {
          el.textContent = realCount;
        }
      });
    }).catch(function () { /* yoksay */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
      fixInitialCartCountBadge();
    });
  } else {
    init(document);
    fixInitialCartCountBadge();
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });

  document.addEventListener('variant:changed', function () {
    setTimeout(function () { init(document); }, 50);
  });
})();
